import NetworkBanner from './NetworkBanner';

export default NetworkBanner;
